/** Unleash release 플래그 — ON 이면 웹 오토뷰업 허용, OFF(미생성 포함)이면 신규 진입을 막고 앱 이용을 안내한다. */
export const WEB_AUTO_VIEWING_FLAG = 'viewup-web-auto-viewing';
